<script>
import TextAnswerAccordionItem from "./TextAnswerAccordionItem.vue";
import UserObject from "../../Firestore/UserObject.js";
//import 'bootstrap/dist/js/bootstrap.js';

export default {
  async mounted() {

    await this.createAccordion(this.qType, this.qIndex);
  },

  data() {
    return {
      accordionList: []
    };
  },

  props: {
    qIndex: {
      type: Number
    },
    qType: {
      type: String
    },
    allResponses: {
      type: Array
    }
  },

  components: {
    TextAnswerAccordionItem
  },

  methods: {
    async createAccordion(qType, qI) {
      if (this.allResponses.length == 0) {
        return [];
      }

      this.accordionList = [];

      for (let i = 0; i < this.allResponses.length; i++) {
        if (this.allResponses == null || this.allResponses[i] == null || this.allResponses[i].responses == null) {
          continue;
        }
        var currResponse = this.allResponses[i].responses[qI]; //Now we have a user's response object to the given question

        var accordionAnswer = {
            userId: "oops",
            questionNumber: 0,
            answerText: null
          };

        if (qType == "text-answer") {

          await UserObject.getProfile(this.allResponses[i].testerID)
            .then(res => {
                let res_data = res.data;
                accordionAnswer.userId = res_data.userName;
            })
            .catch(function (error) { // request failure handler
                that.$data.isLoading = false;
            });

          accordionAnswer.questionNumber = i;
          accordionAnswer.answerText = currResponse.value;
          this.accordionList.push(accordionAnswer);
        }
      }
    }
  }
}

</script>

<!-- This is gonna sound weird, but importing the CSS in <script> will break our component tests because the library jest will
 try to parse the .css as .js and fail. Just link them, trust! -->
<template>
  <div>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous">
    <div class="accordion" id="user_id_question_id_accordion" test-id="accordion">
      Answers:
      <TextAnswerAccordionItem v-for="(answer, index) in accordionList" :key="answer.userId" :user-answer="answer.answerText" :user-id="answer.userId"
                               :question-number="answer.questionNumber" :start-expanded="index === 0"/>
    </div>
  </div>
</template>




// WEBPACK FOOTER //
// src/components/survey-reporting/TextAccordion.vue